// extracted by mini-css-extract-plugin
export default {"container":"Slot_container__qG2d7","btnContainer":"Slot_btnContainer__JUwoj","modalContent":"Slot_modalContent__AqB6v"};